module.exports = __webpack_public_path__ + "img/logo-pnj.9d9b9712.png";